// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1An0O","container":"styles_container__uOjDz","infoSection":"styles_infoSection__3Ixb3"};